<template>
	<vx-card class="w-full">
		<vs-button
			v-if="closeFormShow"
			class="float-right"
			radius
			color="primary"
			type="filled"
			icon-pack="feather"
			icon="icon-x"
			@click="returnPrevRoute"
		></vs-button>
		<form-wizard
			style="width: 50vw"
			color="rgba(var(--vs-primary), 1)"
			title="Création d'un prestataire"
			subtitle="Ajoutez un prestataire et associez lui des contacts"
			nextButtonText="Suivant"
			backButtonText="Retour"
			finishButtonText="Terminer"
		>
			<tab-content
				title="Création du prestataire"
				class="mb-5"
				:before-change="saveProvider"
			>
				<!-- tab 1 content -->
				<div class="vx-row">
					<div class="vx-col w-full mb-2">
						<h3>Ajouter un prestataire</h3>
					</div>
				</div>
				<!-- Site information -->
				<div class="vx-row mt-5">
					<!-- Society Name -->
					<div class="vx-col w-1/2 mb-2">
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="domain" size="small"></vs-icon
									></span>
								</div>
							</template>
							<vs-input
								class="w-full"
								placeholder="Societé"
								v-model="provider.society"
								:style="styleValidator('society')"
								@change="validateOne(provider.society, 'society')"
							/>
						</vx-input-group>
						<vx-tooltip
							v-if="
								validators['society'] && validators['society'].errText !== ''
							"
							:text="errText('society')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
					<!-- Society Website -->
					<div class="vx-col w-1/2 mb-2 flex">
						<vx-input-group class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="language" size="small"></vs-icon
									></span>
								</div>
							</template>

							<vs-input
								v-model="provider.website"
								placeholder="Site web"
								@change="checkWebsite"
								:danger="
									ProviderValidationObjects.websiteValidationObject.notValid
								"
								:danger-text="
									ProviderValidationObjects.websiteValidationObject.errText
								"
							/>
						</vx-input-group>
					</div>
				</div>
				<vs-divider position="center" class="m-10"> ACTIVITY </vs-divider>
				<div class="vx-row mt-5">
					<!-- Society Name -->
					<div class="vx-col w-1/3">
						<vx-input-group class="inlineB bottom w-full">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="domain" size="small"></vs-icon>*</span
									>
								</div>
							</template>
							<vue-tags
								class="w-full"
								placeholder="Tags"
								:active="selectedTags"
								:all="listDomaine"
								:tag-creation-enabled="true"
								tag-list-label=""
								@on-tag-added="onTagAdded($event)"
								@on-tag-removed="onTagRemoved($event)"
								@on-tag-created="onTagAdded($event)"
								@on-tag-list-opened="
									tagStyle = 'z-index: 1 !important; overflow: visible;'
								"
								@on-tag-list-closed="
									tagStyle = 'z-index: 1 !important; overflow: auto;';
									validateOne(society.activity_domain, 'activity_domain');
								"
								:style="tagStyle"
							>
							</vue-tags>
							<template slot="append">
								<vx-tooltip
									v-if="
										validators['activity_domain'] &&
										validators['activity_domain'].errText !== ''
									"
									:text="errText('activity_domain')"
									class="ml-3"
									style="display: inline-block"
								>
									<vs-icon
										icon="error"
										size="medium"
										style="color: red"
									></vs-icon>
								</vx-tooltip>
							</template>
						</vx-input-group>
					</div>
					<div class="vx-col w-1/3">
						<div class="w-full">
							<vs-select
								:name="Math.random()"
								v-model="provider.type"
								class="w-full select-large"
								autocomplete
								placeholder="Type"
								id="select-control-width"
							>
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.type"
									v-for="(item, index) in providerTypes"
									class="w-full"
								/>
							</vs-select>
						</div>
					</div>
					<div class="vx-col w-1/3">
						<p>Note du prestataire</p>
						<star-rating :star-size="20" v-model="provider.rate"></star-rating>
					</div>
				</div>
				<!-- Remise Negociate -->
				<div class="vx-row mt-10 flex-end">
					<!-- Left Column - Society Name -->
					<div class="vx-col flex flex-col w-2/3">
						<!-- Chip Section (Upper Column) -->
						<span class="w-full mb-2"><b>Expertises</b></span>
						<div class="w-full" v-if="providerTempOptions">
							<div class="flex flex-wrap">
								<span
									v-for="chip in providerTempOptions"
									:key="chip.value"
									class="mb-2"
								>
									<vs-chip
										@click="removeChip(chip)"
										style="justify-content: center; justify-items: center"
										closable
									>
										{{ chip.text }}
									</vs-chip>
								</span>
							</div>
						</div>

						<!-- Suggest Expertise Section (Middle Column) -->
						<div class="w-full">
							<vue-simple-suggest
								class="w-full"
								pattern="\w+"
								v-model.lazy="provider.service_id"
								:list="getExpertiseOptionsList"
								:max-suggestions="10"
								:min-length="1"
								:debounce="200"
								:filter-by-query="true"
								:prevent-submit="true"
								mode="input"
								:nullable-select="true"
								ref="suggestComponent"
								placeholder="Ajoutez une expertise..."
								value-attribute="value"
								display-attribute="text"
								style="border: 0"
								@select="selectExpertise"
							>
								<template slot="misc-item-above" slot-scope="{ suggestions }">
									<template v-if="suggestions.length <= 0"> </template>
								</template>

								<div
									slot="suggestion-item"
									slot-scope="scope"
									:title="scope.suggestion.description"
								>
									<div class="text">
										<span v-html="boldenSuggestion(scope)"></span>
									</div>
								</div>
							</vue-simple-suggest>
						</div>

						<!-- Button Section (Bottom) -->
						<div v-if="checkExpertiseInList()" class="mt-auto">
							<vs-button
								color="primary"
								type="filled"
								@click="addNewExpertise()"
								class="w-full"
							>
								Ajouter nouvelle expertise
							</vs-button>
						</div>
					</div>

					<!-- Right Column - Refund Input -->
					<div class="flex flex-col justify-end mb-4">
						<label>Remise négociée %</label>
						<vs-input type="number" v-model="provider.refund" rows="3" />
					</div>
				</div>

				<!-- /ACTIVITY_DOMAIN -->
				<div class="vx-row mt-5">
					<div class="vx-col w-full">
						<label for="commentary">Commentaire</label>
						<vs-textarea v-model="provider.commentary" rows="3" />
					</div>
				</div>
			</tab-content>

			<!-- tab 2 content -->
			<tab-content title="Ajout des contacts" class="mb-5">
				<div class="vx-col" v-if="providerContact && !clickAddContact">
					<div class="vx-row center_div">
						<vs-table :data="providerContact">
							<template slot="thead">
								<vs-th>Civilité</vs-th>
								<!-- Madame ou Monsieur -->
								<vs-th>Prénom</vs-th>
								<!-- Prénom -->
								<vs-th>Nom</vs-th>
								<!-- Nom -->
								<vs-th>Fonction</vs-th>
								<!-- Commercial ou Facturation -->
								<vs-th>Email</vs-th>
								<!-- Email -->
								<vs-th>Téléphone</vs-th>
								<!-- Téléphone -->
								<vs-th>Accès Dashboard</vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td>{{ getUserCivility(data[indextr].civility) }}</vs-td>
									<!-- Madame ou Monsieur -->
									<vs-td>{{ data[indextr].firstname }}</vs-td>
									<!-- Prénom -->
									<vs-td>{{ data[indextr].lastname }}</vs-td>
									<!-- Nom -->
									<vs-td>{{ getUserTitle(data[indextr].user_type) }}</vs-td>
									<!-- Commercial ou Facturation -->
									<vs-td>{{ data[indextr].email }}</vs-td>
									<!-- Email -->
									<vs-td>{{ data[indextr].phone }}</vs-td>
									<!-- Téléphone -->
									<vs-td>{{
										getUserDashboardAccess(data[indextr].hasAccess)
									}}</vs-td>
									<!-- hasAccess to Dashboard -->
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</div>
				<div class="vx-col mt-4">
					<div class="vx-row center_div">
						<vs-button
							type="filled"
							@click="showContactForm"
							v-if="!clickAddContact"
							>Ajouter un contact</vs-button
						>
					</div>
					<div>
						<ContactForProvider
							:contactAdded="contactAdded"
							:provider="providerId"
							:show="clickAddContact"
							@closeForm="closeContactForm"
							@closeFormAfterContactAdded="refreshData"
						/>
					</div>
				</div>
			</tab-content>

			<!-- CONTROL UI FOOTER BUTTON -->
			<template slot="footer" slot-scope="props">
				<div class="wizard-footer-left">
					<wizard-button
						v-if="props.activeTabIndex > 0 && !props.isLastStep"
						@click.native="props.prevTab()"
						:style="props.fillButtonStyle"
						>Précédent</wizard-button
					>
				</div>
				<div class="wizard-footer-right">
					<wizard-button
						v-if="!props.isLastStep"
						@click.native="props.nextTab()"
						class="wizard-footer-right"
						:style="props.fillButtonStyle"
						>Suivant</wizard-button
					>

					<wizard-button
						v-else-if="!clickAddContact"
						@click.native="returnPrevRoute"
						class="wizard-footer-right finish-button"
						:style="props.fillButtonStyle"
						>{{ props.isLastStep ? "Terminer" : "Suivant" }}</wizard-button
					>
				</div>
			</template>
		</form-wizard>
	</vx-card>
</template>

<script>
import StarRating from "vue-star-rating";
import Provider from "@/entities/Provider";
import Validator from "@/entities/Validator";
import { Service } from "@/entities/Service";
import { ProvidersServices } from "@/entities/ProvidersServices";
import utilsMixin from "@/mixins/utilsMixin";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import validatorMixin from "@/mixins/validatorMixin";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import ContactForProvider from "../contact/ContactForProvider";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";
import { VueTags } from "vue-tags-component";

export default {
	name: "ProviderForm",
	mixins: [utilsMixin, dbFieldConvertor, validatorMixin],
	components: {
		StarRating,
		VueSimpleSuggest,
		FormWizard,
		TabContent,
		ContactForProvider,
		WizardButton,
		VxTooltip,
		VueTags,
	},
	data() {
		return {
			provider: Provider.getFormFields(),
			providerId: null,
			closeFormShow: true,
			// Society Object
			society: {},
			providerContact: [],
			contactAdded: 0,
			clickAddContact: true,
			apiUrl: this.$store.state.backendApiUrl,
			commercials: null,
			// Validator Objects
			ProviderValidationObjects: {
				nameValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "nameConstraint",
					required: true,
				},
				siretValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "siretConstraint",
					required: false,
				},
				commercial_idValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "commercial_idConstraint",
					required: true,
				},
				originValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "originConstraint",
					required: true,
				},
				websiteValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: false,
				},
				is_ecommerceValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "is_ecommerceConstraint",
					required: true,
				},
				statusValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "statusConstraint",
					required: false,
				},
			},

			// FORM SELECT OPTIONS
			expertiseOptions: [],
			providerTempOptions: [],
			validators: {},
			check: true,

			//Tags
			selectedTags: [],
			listDomaine: [],
			tagStyle: "z-index: 1 !important;",

			providerTypes: [],
		};
	},
	watch: {
		contactAdded: function () {
			//console.log("contactAdded called");
			// Fetch contact linked to the society
			this.getProviderContact();
		},
	},
	created() {
		this.setServiceOptions();
		this.getDomain();
		this.getProviderType();
	},
	methods: {
		getProviderType() {
			this.$http
				.get(this.apiUrl + "providers/get_types/")
				.then((providerT) => {
					//console.log("TYPES", providerT.data);
					this.providerTypes = providerT.data;
					// this.providerTempOptionsOld = this.getServiceFromProvider(this.$route.params.providerId)
				})
				.catch((err) => {
					//console.log(err);
				});
		},
		onTagAdded(tag) {
			if (this.selectedTags.indexOf(tag) < 0) this.selectedTags.push(tag);
		},

		onTagRemoved(tag) {
			this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
		},

		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";

			let constname = "";

			switch (name) {
				case "society":
					value ? (value = String(val)) : (value = "");
					constname = "nameConstraint";
					break;
				case "activity_domain":
					constname = "statusConstraint";
					value = this.selectedTags.length;
					break;
				default:
					"";
			}

			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);

			if (
				this.validators[name].valid == false &&
				this.validators[name].errText == ""
			) {
				this.validators[name].errText = "Ce champ ne peut être vide.";
				if (name == "activity_domain" && value == 0)
					this.validators[name].errText = "Ce champ ne peut être vide.";
				if (name == "activity_domain" && value > 0)
					this.validators[name].errText = "";
			}

			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return "border: 1px solid red !important; border-radius: 0 5px 5px 0;";
			} else if (this.validators[name] && this.validators[name].errText == "") {
				return "border: 1px solid green !important; border-radius: 0 5px 5px 0;";
			} else {
				return "border: none !important; border-radius: none;";
			}
		},
		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Providers.vue
		 */
		async saveProvider() {
			this.check = true;
			let fields = ["society", "activity_domain"];
			for (let i = 0; i < fields.length; i++) {
				let name = "";
				let value = this.provider[fields[i]];
				value == 0 ? (value = "0") : "";

				switch (fields[i]) {
					case "society":
						this.provider[fields[i]] ? (value = String(value)) : (value = "");
						name = "nameConstraint";
						break;
					case "activity_domain":
						name = "statusConstraint";
						value = this.selectedTags.length;
						break;
					default:
						break;
				}
				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);

				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				) {
					this.validators[fields[i]].errText = "Ce champ ne peut être vide.";

					if (fields[i] == "activity_domain" && value == 0)
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
					if (fields[i] == "activity_domain" && value > 0)
						this.validators[fields[i]].errText = "";
				}

				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
				this.$forceUpdate();
			}
			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				await this.$http
					.post(this.apiUrl + "providers/add", {
						commentary: this.provider.commentary,
						status: 1,
						rate: this.provider.rate,
						society: this.provider.society,
						website: this.provider.website,
						tags: this.selectedTags,
						refund: this.provider.refund,
						type: this.provider.type,
					})
					.then(async (res) => {
						//console.log("res.data", res.data);
						this.providerId = res.data.insertId;
						//Ajout des expertises
						let providerServiceList = [];
						for (let service of this.providerTempOptions) {
							let providerService = new ProvidersServices({
								provider_id: this.providerId,
								service_id: service.value,
							});
							providerServiceList.push(
								providerService.createProvidersService((err, res) => {
									if (err) console.log(err);
									// if(res) //console.log(res);
								})
							);
						}
						//console.log("Promise.all BEGIN");
						await Promise.all(providerServiceList).then((err, res) => {
							//console.log("Promise.all");
							if (err) console.log(err);
							if (res) {
								//console.log("res", res);
								// Send a success notification to the user
								this.$vs.notify({
									title: "Succès",
									text: "Prestataire ajouté avec succès.",
								});
								this.$store.dispatch("getAllProviders");
								this.$store.dispatch("getAllServices");
							}
						});
						//console.log("Promise.all END");
					})
					.catch((err) => {
						//console.log(err);
						this.$vs.notify({
							title: "Echec",
							text: "Le prestataire n'a pas été ajouté..",
						});
						return false;
					});
				return true;
			}
		},

		/**
		 * Get all services options
		 */
		setServiceOptions() {
			Service.getAllServices((err, res) => {
				let final = [];
				for (let service of res) {
					final.push({ text: service.name, value: service.id });
				}
				this.expertiseOptions = final;
			});
		},

		getDomain() {
			this.$http
				.get(this.apiUrl + "tags/all")
				.then((res) => {
					let tmp = res.data;
					for (let tag of tmp) {
						tag["name"] = tag.tag_name;
						tag["slug"] = tag.tag_name;
						delete tag.tag_name;
					}
					this.listDomaine = tmp;
				})
				.catch((err) => console.log(err));
		},

		/**
		 * Fetch all contact corresponding to a society from our API
		 */
		getProviderContact() {
			this.$http
				.get(this.apiUrl + "usersProviders/getup/" + this.providerId)
				.then((res) => {
					this.providerContact = res.data;
					//console.log("res.data", res.data);
				})
				.catch((err) => console.log(err));
		},

		showContactForm() {
			this.clickAddContact = true;
		},

		closeContactForm(value) {
			this.clickAddContact = value;
		},

		refreshData(value) {
			this.contactAdded += value;
			this.clickAddContact = false; // Close the form
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},

		getExpertiseOptionsList() {
			return this.expertiseOptions;
		},
		selectExpertise(selectedExpertise) {
			//ADD TO TEMPORARY EXPERTISE LIST
			if (selectedExpertise != null) {
				if (this.providerTempOptions.length > 0) {
					if (
						this.providerTempOptions.filter(function (expertise) {
							return expertise.value === selectedExpertise.value;
						}).length > 0
					) {
						return false;
					}
					if (
						this.providerTempOptions.filter(function (expertise) {
							return expertise.value === selectedExpertise.value;
						}).length <= 0
					) {
						this.providerTempOptions.push(selectedExpertise);

						return true;
					}
				} else {
					this.providerTempOptions.push(selectedExpertise);
					return true;
				}
			}
			//console.log("selectExpertise");
		},
		boldenSuggestion(scope) {
			if (!scope) return scope;
			const { suggestion, query } = scope;
			let result = this.$refs.suggestComponent.displayProperty(suggestion);
			if (!query) return result;
			const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [""];
			return result.replace(
				new RegExp("(.*?)(" + texts.join("|") + ")(.*?)", "gi"),
				"$1<b>$2</b>$3"
			);
		},

		removeChip(chip) {
			this.providerTempOptions.splice(
				this.providerTempOptions.indexOf(chip),
				1
			);
		},
		addNewExpertise() {
			let newService = new Service({
				name: this.provider.service_id,
			});
			newService.createService((err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						this.setServiceOptions();
						this.selectExpertise({
							text: this.provider.service_id,
							value: res.data.id,
						});
					}
			});
			//console.log("addNewExpertise");
		},

		checkExpertiseInList() {
			if (this.provider.service_id != "") {
				return this.expertiseOptions.filter(
					(expertise) => expertise.text === this.provider.service_id
				).length > 0
					? false
					: true;
			} else {
				return false;
			}
		},

		/**
		 * Checks if Website is present and valid
		 */
		checkWebsite() {
			this.checkHandler(
				this.provider.website,
				this.ProviderValidationObjects.websiteValidationObject
			);
		},

		/**
		 * Check if all required fields for COntract are valid
		 * @return true if all are valid else return false if at least one is not valid
		 */
		checkAllFieldsError() {
			let fieldsErrorOk = true;

			Object.entries(this.ProviderValidationObjects).forEach((entry) => {
				const [key, value] = entry;
				if (value.notValid && fieldsErrorOk) {
					fieldsErrorOk = false;
				}
			});

			return fieldsErrorOk;
		},
	},
};
</script>

<style scoped>
@import "../../../assets/scss/vuexy/extraComponents/autocomplete.scss";

.center_div {
	justify-content: center;
}
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.table_sizing {
	max-width: 600px;
}

.bottom {
	align-self: flex-end;
}
.center {
	align-self: center;
}
.input-group-border {
	border: solid rgb(195, 195, 195) 1px;
	border-radius: 10px;
	padding: 0;
}

.right_element {
	justify-content: flex-end;
}
</style>
